module.exports = __webpack_public_path__ + "static/media/view2.1e4c89f8.jpg";